import type { ChatCycle } from "./types.js";

// CYCLES walk the four labeled steps (orient → search → open → query) on
// qtl-index, so the animation literally demonstrates the progressive-disclosure
// surface described by the tool-flow legend on the QTLx solutions page. Unlike
// GEOx (which ends on an audit step), QTLx ends on query_table — running SQL
// against a study's published parquet table. Numbers and rows are pulled from
// the live qtl-index MCP (corpus as of 2026-04-30; study 41507467, Soremekun
// 2026, Supplementary Table 4 "Independent cis and trans pQTLs").
export const QTLX_CYCLES: ChatCycle[] = [
  {
    server: "qtl-index · orient",
    user: "What's in the xQTL index?",
    tool: "corpus_overview",
    args: [],
    result: {
      kind: "rows",
      rows: [
        { accession: "studies", title: "curated xQTL papers", meta: "249" },
        { accession: "modalities", title: "eQTL · pQTL · sQTL · mQTL · caQTL", meta: "23 types" },
        { accession: "tables", title: "sentinel · coloc · MR · fine-map", meta: "1,566" },
      ],
      chip: "~200 tokens",
    },
    assistant:
      "249 curated xQTL studies across 23 QTL modalities, 1,566 queryable tables. What do you want to drill into?",
  },
  {
    server: "qtl-index · search",
    user: "Plasma pQTL studies in African-ancestry cohorts.",
    tool: "search_studies",
    args: [
      { k: "qtl_type", v: '"pQTL"' },
      { k: "tissue", v: '"plasma"' },
      { k: "ancestry", v: '"African"' },
    ],
    result: {
      kind: "rows",
      rows: [
        { accession: "41507467", title: "Soremekun 2026 · Ugandan plasma pQTL (T2D)", meta: "olink" },
        { accession: "40877285", title: "Bhak 2025 · sex-dimorphic pQTL, 4 ancestries", meta: "N=30,272" },
        { accession: "preprint", title: "Groza 2026 · sickle-cell proteogenomics", meta: "5,411 proteins" },
      ],
      chip: "~50 / result",
    },
    assistant:
      "Matched studies span Olink and mass-spec proteomics in African-ancestry cohorts. Open one?",
  },
  {
    server: "qtl-index · open",
    user: "Open 41507467.",
    tool: "study_detail",
    args: [{ k: "study_id", v: '"41507467"' }],
    result: {
      kind: "rows",
      rows: [
        { accession: "platform", title: "Olink Explore", meta: "olink" },
        { accession: "ancestry", title: "African — Ugandan", meta: "single_cohort" },
        { accession: "downstream", title: "coloc · MR · PheWAS", meta: "5 analyses" },
      ],
      chip: "~500+ / record",
    },
    assistant:
      "525 Ugandan participants, Olink Explore, 399 independent pQTLs. Its tables are queryable — want the top hits?",
  },
  {
    server: "qtl-index · query",
    user: "Top cis-pQTL hits by p-value.",
    tool: "query_table",
    args: [
      { k: "table", v: '"…Supplementary_Table_4"' },
      { k: "sql", v: "\"WHERE cis_trans='cis' ORDER BY p_value LIMIT 3\"" },
    ],
    result: {
      kind: "rows",
      rows: [
        { accession: "SERPINA12", title: "14:94972774", meta: "p=1.1e−95" },
        { accession: "PSCA", title: "8:143760836", meta: "p=2.6e−80" },
        { accession: "CEACAM1", title: "19:43028272", meta: "p=1.9e−75" },
      ],
      chip: "SQL → parquet",
    },
    assistant:
      "Top three cis-pQTLs straight from the published supplement — no download, no reformatting, no schema guessing.",
  },
];
